<template>
  <LayoutAuthPrimary>
    <div :style="style.container">
      <CardSecondary :style="style.card">
        <HeaderLargePrimary :style="style.header">
          {{ headerText }}
        </HeaderLargePrimary>
        <ImagePrimary
          :src="require('@img/robot.png')"
          :style="style.image"
        />
        <div :style="style.innerContainer">
          <template v-if="signUpLinkHasExpired">
            <TextRegular :isInline="true">
              The sign-up link has expired. To create your account, please re-enter your email address
            </TextRegular>
            <LinkPrimary
              :isInline="true"
              :to="{ name: 'signup' }"
            >
              here<!--
         --></LinkPrimary><!--
         --><TextRegular :isInline="true"><!--
           -->, and a new sign-up link will be sent to you.
            </TextRegular>
          </template>
          <template v-else-if="tenantInvitationLinkHasExpired">
            <TextRegular :isInline="true">
              The invitation link has expired. You can still join by asking the workspace admin to resend the invitation.
            </TextRegular>
          </template>
          <template v-else-if="passwordResetLinkHasExpired">
            <TextRegular :isInline="true">
              The password reset link has expired. To reset your password, please re-enter your email address
            </TextRegular>
            <LinkPrimary :isInline="true">
              here<!--
         --></LinkPrimary><!--
         --><TextRegular :isInline="true"><!--
                                          -->, and a new password reset link will be sent to you.
            </TextRegular>
          </template>
        </div>
      </CardSecondary>
    </div>
  </LayoutAuthPrimary>
</template>

<script>
  import CardSecondary from '@modules/v2/card/card-secondary'
  import HeaderLargePrimary from '@modules/v2/header/header-large-primary'
  import ImagePrimary from '@modules/v2/image/image-primary'
  import LayoutAuthPrimary from '@modules/v2/layout/layout-auth-primary'
  import LinkPrimary from '@modules/v2/link/link-primary'
  import TextRegular from '@modules/v2/text/text-regular'
  import { Layout } from '@js/styles'

  export default {
    name: 'ExpirationError',
    components: {
      CardSecondary,
      HeaderLargePrimary,
      ImagePrimary,
      LayoutAuthPrimary,
      LinkPrimary,
      TextRegular,
    },
    props: {
      state: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data: function () {
      return {
        style: {
          card: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            height: 'fit-content',
            justifyContent: 'space-between',
            maxWidth: '480px',
            minHeight: '400px',
            padding: `${Layout.space.xl} ${Layout.space.md}`,
            width: '90%',
          },
          container: {
            alignItems: 'center',
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            justifyContent: 'center',
            padding: Layout.space.lg,
            width: '100%',
          },
          header: {
            display: 'block',
            textAlign: 'center',
            width: '100%',
          },
          image: {
            margin: `${Layout.space.md} 0`,
            maxWidth: '160px',
            width: '100%',
          },
          innerContainer: {
            width: '100%',
          },
        },
      };
    },
    computed: {
      passwordResetLinkHasExpired: function () {
        return this.state.linkIsExpired && this.state.passwordResetCode;
      },
      signUpLinkHasExpired: function () {
        return this.state.linkIsExpired && this.state.emailVerificationCode;
      },
      tenantInvitationLinkHasExpired: function () {
        return this.state.linkIsExpired && this.state.tenantInvitationCode;
      },
      headerText: function () {
        if (this.signUpLinkHasExpired) {
          return 'Sign-up Link Has Expired';
        } else if (this.tenantInvitationLinkHasExpired) {
          return 'Invitation Link Has Expired';
        } else if (this.passwordResetLinkHasExpired) {
          return 'Password Reset Link Has Expired';
        }
        return '';
      },
    },
  };
</script>
